// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navigation-dropdown__root {
	display: inline-block;
	position: relative;
	z-index: 2;
}

.navigation-dropdown__root .navigation-dropdown__hover-target {
	cursor: pointer;
}

.navigation-dropdown__root:hover .navigation-dropdown__hover-target {
	filter: invert();
	opacity: 0.8;
}

.navigation-dropdown__root .navigation-dropdown__link {
	display: inline-block;
	width: 100%;
	margin: -9px -2px;
	padding: 9px 0;
	color: inherit;
}
`, "",{"version":3,"sources":["webpack://./src/css/components/SiteHeader/NavigationDropdown.css"],"names":[],"mappings":"AAAA;CACC,qBAAqB;CACrB,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,qBAAqB;CACrB,WAAW;CACX,iBAAiB;CACjB,cAAc;CACd,cAAc;AACf","sourcesContent":[".navigation-dropdown__root {\n\tdisplay: inline-block;\n\tposition: relative;\n\tz-index: 2;\n}\n\n.navigation-dropdown__root .navigation-dropdown__hover-target {\n\tcursor: pointer;\n}\n\n.navigation-dropdown__root:hover .navigation-dropdown__hover-target {\n\tfilter: invert();\n\topacity: 0.8;\n}\n\n.navigation-dropdown__root .navigation-dropdown__link {\n\tdisplay: inline-block;\n\twidth: 100%;\n\tmargin: -9px -2px;\n\tpadding: 9px 0;\n\tcolor: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
